import type { CatalogOf } from '../types';
import type { en } from './en';
import { hiCore } from './hi.core';
import { hiSessions } from './hi.sessions';
import { hiClinical } from './hi.clinical';

export const hi: CatalogOf<typeof en> = {
  ...hiCore,
  ...hiSessions,
  ...hiClinical,
};
